import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const activeRowModal: any = ref({ data: null });

const data = {
  readyToUseFilters: {},
  filter: {
    searchResult: true,
    searchText: true,
    title: "",
    textSearch: true,
    pageName: "EventPageFilter",
    genre: "eventPageFilter",
    filters: [
      // {
      //   title: "Scope Related",
      //   type: "siteAndGroup",
      //   selectType: "multiple",
      //   selectedLabel: null,
      //   vmodel: "",
      //   requestKey: "groupIds",
      //   apiEquivalent: "groupIds",
      //   param: "name",
      //   data: [],
      // },
      {
        title: "Filters",
        type: "eventFilter",
        requestKey: "",
        selectType: "eventFilter",
        selectedLabel: null,
        vmodel: "",
      },
      {
        title: "Advanced Filter",
        type: "eventAdvancedFilter",
        requestKey: "",
        selectType: "eventAdvancedFilter",
        selectedLabel: null,
        vmodel: "",
      },
      // {
      //   title: "Text Search",
      //   apiEquivalent: "textSearch",
      //   type: "wordstyped",
      //   requestKey: "fullTextSearch",
      //   param: "Text Search",
      // },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        requestKey: "",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
    ],
    savedFilter: {
      columns: [
        {
          label: "savedeventfilters",
          field: "title",
          sortable: false,
        },
        {
          label: "",
          sortable: false,
          components: [
            {
              component: "tableLoadComponent",
              emit: "eventInspectionLoad",
            },
          ],
        },
      ],
      rows: [],
      total: 5,
      sortable: {
        order: "filtername",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
    },
  },
  header: {
    // title: "allevents",
    // components: [],
    navigation: [
      {
        title: "allevents",
        url: "all-events",
        navFilter: "cardNavFilter",
        components: [],
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      // id: "exportable-table",
      // export: {
      //   fileName: "event_inspection",
      // },
      download: true,
      dateFilter: true,
      columns: [
        {
          label: "exactTime",
          labelTooltip: "exactTimeTooltip",
          sortable: true,
          excelField: "reportEventDate",
          components: [
            {
              component: "tableDateFormatter",
              field: "reportEventDate",
            },
          ],
        },
        {
          label: "severity",
          field: "severity",
          width: "100px",
          excelField: "severity",
          sortable: true,
          truncate: {
            position: "middle",
            first: 0,
            last: 0,
            tableShow: function (row: any) {
              let type = "";
              switch (row.severity) {
                case "Default":
                  type = "level_one";
                  break;
                case "Lowest":
                  type = "level_one";
                  break;
                case "Low":
                  type = "level_two";
                  break;
                case "Medium":
                  type = "level_three";
                  break;
                case "High":
                  type = "level_four";
                  break;
                case "Critical":
                  type = "level_five";
                  break;
              }
              return (
                '<span class="ag-label text-white small ag-background_' +
                type +
                '">' +
                (row.severity === "Default" ? "Lowest" : row.severity) +
                "</span>"
              );
            },
            show: function (row: any) {
              let text = "";
              switch (row.severity) {
                case "Default":
                  text = "Severity 1 events considered as lowest impact";
                  break;
                case "Lowest":
                  text = "Severity 1 events considered as lowest impact";
                  break;
                case "Low":
                  text = "Severity 2 events considered as low impact";
                  break;
                case "Medium":
                  text = "Severity 3 events considered as medium impact";
                  break;
                case "High":
                  text = "Severity 4 events considered as high impact";
                  break;
                case "Critical":
                  text = "Severity 5 events considered as critical impact";
                  break;
              }
              return "<p>" + text + "</>";
            },
          },
        },
        {
          label: "endpointHostName",
          field: "computer",
          excelField: "computerName",
          sortable: true,
          width: "180px",
          components: [
            {
              component: "tableModalComponent",
              field: "computerName",
              truncate: {
                position: "middle",
                first: 6,
                last: 6,
                width: "400px",
                show: function (row: any) {
                  return (
                    "<div><p style='width: 130px'><strong>Computer Name </strong> </br>" +
                    row.computerName +
                    "</p><p style='width: 130px'><strong>Policy Version </strong> </br>" +
                    (row.computerPolicyVersion
                      ? row.computerPolicyVersion
                      : row.policyVersion) +
                    "</p><p style='width: 130px'><strong>Group </strong> </br>" +
                    row.computerGroup +
                    "</p></div>"
                  );
                },
              },
              selectedTab: "ag-tab_computer",
            },
          ],
        },
        {
          label: "user",
          field: "user",
          excelField: "user",
          sortable: true,
          truncate: {
            position: "middle",
            first: 6,
            last: 6,
          },
        },
        {
          label: "action",
          field: "action",
          excelField: "action",
          sortable: true,
          truncate: {
            position: "middle",
            first: 0,
            last: 0,
            tableShow: function (row: any) {
              let label = "";
              if (row.result.toLowerCase() === "allow") {
                label = '<span class="green-indicator"></span>';
              } else if (row.result.toLowerCase() === "block") {
                label = '<span class="red-indicator"></span>';
              }
              return (
                "<div class='d-flex align-items-center'> " +
                label +
                " <span>" +
                row.action +
                " " +
                (row.access ? row.access : "") +
                "</span> </div>"
              );
            },
            show: function (row: any) {
              return (
                "<span>" +
                row.eventType +
                " " +
                (row.access ? row.access : "") +
                "</span>"
              );
            },
          },
        },
        {
          label: "actor",
          field: "actor",
          excelField: "actor",
          // sortable: true,
          truncate: {
            position: "middle",
            first: 6,
            last: 6,
            na: true,
          },
        },
        {
          label: "actorPath",
          field: "actorPath",
          excelField: "actorPath",
          // sortable: true,
          truncate: {
            position: "middle",
            tooltipPosition: "left",
            first: 6,
            last: 6,
            na: true,
          },
        },
        {
          label: "targetContext",
          field: "target",
          excelField: "target",
          // sortable: true,
          display: function (row: any) {
            if (row.eventType == "AgentEvent") {
              return (
                "<div class='d-flex flex-column'><p class='mb-1'>" +
                row.source +
                ":</p><p class='mb-1'>" +
                row.target +
                "</p></div>"
              );
            }
            return row.target;
          },
        },
        {
          label: "targetPath",
          field: "targetPath",
          excelField: "targetPath",
          // sortable: true,
          truncate: {
            position: "middle",
            tooltipPosition: "left",
            first: 6,
            last: 6,
          },
        },
        {
          label: "count",
          field: "eventCount",
          excelField: "count",
          width: "80px",
          sortable: true,
          display: function (row: any) {
            return "<p class='event-count-label'>" + row.eventCount + "</p>";
          },
        },
        {
          label: "fullEvent",
          field: "edit",
          width: "80px",
          components: [
            {
              component: "tableExpandComponent",
              // label: "Details",
            },
          ],
        },
      ],
      rows: [],
      total: 10000,
      sortable: {
        order: "ReportedEventDate",
        sort: "desc",
      },
      page: 1,
      pageSize: 10,
      isLoading: false,
      fetchTable: (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body: any = { filters, options };
        if (body.filters && body.filters.download) {
          delete body.filters?.CompanyGuid;
          delete body.filters?.DataFormat;
          delete body.filters?.fields;
          delete body.filters?.lineLimit;
          delete body.filters?.download;
        }
        store.dispatch(GeneralActionTypes.GET_EVENTS, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "OK",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "overallview",
          component: "ag-overall",
          options: { activeRowModal },
        },
        {
          title: "processtree",
          component: "ag-processtree",
        },
        {
          title: "endpoint",
          component: "ag-computer",
        },
        {
          title: "hashdetails",
          component: "ag-hashdetail",
        },
        {
          title: "hashxmldetail",
          component: "ag-hashxmldetail",
        },
        {
          title: "policy",
          component: "ag-event-policy",
        },
      ],
    },
  ],
};

export default data;
